import { useTranslation } from "react-i18next";
import { enUS, ptBR } from "date-fns/locale";
import type { Locale } from "date-fns";

const DATE_FNS_LOCALES: Record<string, Locale> = {
  en: enUS,
  "pt-BR": ptBR,
};

export function useLocale() {
  const { i18n } = useTranslation();
  const language = i18n.language;
  const dateFnsLocale = DATE_FNS_LOCALES[language] ?? enUS;
  return { language, dateFnsLocale };
}
